import * as createCulture from "@/api/cultures/create";

export default {
	namespaced: true,
	state: {
		culture: {},
		error: null,
	},
	getters: {
		readCulture: (state) => state.culture,
		readError: (state) => state.error,
	},
	mutations: {
		SET_CULTURE(state, payload) {
			state.culture = payload;
		},
		SET_ERROR(state, payload) {
			state.error = payload;
		},
	},
	actions: {
		async createCulture({ commit, getters, rootGetters }) {
			let token = rootGetters["loginStore/readToken"];
			let createCultureRes = await createCulture
				.createCulture(token, getters.readCulture)
				.then(() => {
					return true;
				})
				.catch((error) => {
					if (error.response) {
						let message =
							error.response.data.message ||
							error.response.data.detail[0].msg;
						message == "Token expired"
							? commit("loginStore/SET_ACCESS_TOKEN", null, {
									root: true,
							  })
							: message
							? commit("SET_ERROR", message)
							: commit("SET_ERROR", "Algo salió mal");
					} else {
						console.log(error);
						commit("SET_ERROR", error);
					}
				});
			return createCultureRes;
		},
	},
};
